import * as uuid from "uuid";
import {auth0ClientProvider} from "../components/auth/SSO";

const baseUrl = `${process.env.REACT_APP_SKADI_REALTIME_BASE_URL}/api/v1/realtime`;

const handlers = [];

let webSocket = undefined;

function connect() {
    if (webSocket) return Promise.resolve();

    return auth0ClientProvider.getTokenSilently()
        .then((token) => {
            const ws = new WebSocket(baseUrl + `?access_token=${token}`);

            ws.onmessage = (message) => {
                const payload = JSON.parse(message.data);

                handlers.forEach((callback) => {
                    callback(payload);
                });
            };

            ws.onclose = () => {
                setTimeout(() => connect(), 1000);
            };

            webSocket = ws;

            return Promise.resolve();
        });
}

function hubSubscribe(hubId, handler) {
    send("HUB_SUBSCRIBE", {"hub_id": hubId});
    handlers.push(handler);
}

function hubUnsubscribe(hubId, handler) {
    send("HUB_UNSUBSCRIBE", {"hub_id": hubId});
    delete handlers[handlers.indexOf(handler)];
}

function send(event, payload) {
    webSocket.send(JSON.stringify({
        id: uuid(),
        event: event,
        payload: payload
    }));
}

export {
    connect,
    send,
    hubSubscribe,
    hubUnsubscribe
}